import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { SearchProvider } from '../context/SearchContext';
import { SearchInput } from './Input';
import SearchResults from './Results';
import { useSearch } from '../context/SearchContext';
// Inner component that uses the search context
const SearchComponent = (props) => {
    const { setOpen, state } = useSearch();
    const divRef = useRef(null);
    const { isOpen } = state;
    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (divRef.current && !divRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [setOpen]);
    // Close on escape key from anywhere in the search component
    const handleEscapeKey = (e) => {
        if (e.key === 'Escape' && isOpen) {
            setOpen(false);
            // Focus back on the search input
            const searchInput = document.getElementById('site-search-input');
            if (searchInput) {
                searchInput.focus();
            }
        }
    };
    return (_jsxs("div", Object.assign({ ref: divRef, className: 'relative w-full max-w-6xl mx-auto', onKeyDown: handleEscapeKey, role: 'search', "aria-label": 'Site search' }, { children: [_jsx(SearchInput, Object.assign({}, props)), _jsx(SearchResults, {})] })));
};
// Main component that provides the search context
export const AutocompleteSearch = (props) => {
    return (_jsx(SearchProvider, { children: _jsx(SearchComponent, Object.assign({}, props)) }));
};
